export const CONSTANTS = {
	EMPTY: '',
	DEFAULT: '-',
	NO_DATE: 'no date',
	NO_VALUE: 'no value',
	NOT_AVAILABLE: 'n.a.',
};
